module.exports = __webpack_public_path__ + "img/1.1bb4b35b.jpg";